/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import ClientGallery from '../components/ClientGallery'
import AdminUpload from '../components/AdminUpload'
import Selections from '../components/Selections'
import Login from '../components/Login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/gallery/:email',
    name: 'gallery',
    component: ClientGallery
    // component: () => import(/* webpackChunkName: "about" */ '../components/ClientGallery.vue')
  },
  {
    path: '/',
    redirect: to => {
      window.location.href = '/zic/static/landing.html'
    }
  },
  {
    path: '/admin-upload',
    name: 'admin-upload',
    component: AdminUpload
  },
  {
    path: '/selections',
    name: 'selections',
    component: Selections
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js